import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'lib-experian-logo-svg',
  templateUrl: './lib-experian-logo-svg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibExperianLogoSvgComponent {
  @Input() isMobile = false;
  @Input() width = 141; //168;
}
